import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { plainToClass } from 'class-transformer';
import { BookmarkModel } from '../bookmarks/models/bookmark.model';
import { exploreMenu } from './data/explore-menu';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
const webOnlyTags = ['web platform', '!obsolete'];
export class ExploreService {
    constructor(http) {
        this.http = http;
    }
    search(keyword = '', tags = [], lang = 'en') {
        // seperate keywords
        const queryKeywords = keyword.split(/[ ]+/)
            .join('+');
        // quote seperate tags
        const queryTags = webOnlyTags.concat(tags)
            .map((tag) => `"${tag}"`)
            .join('+');
        return this.http.get(`/search?k=${queryKeywords}&t=${queryTags}&ol=${lang}`)
            .pipe(map((result) => this.resultsToBookmarks(result)));
    }
    getAnatomyCategory(query, category, lang) {
        return this.search(query, [category], lang);
    }
    // get condition model search result
    getConditionModel(id) {
        const dbID = this.toDatabaseContentId(id);
        return this.http.get(`/search/conditions?q=${dbID}`)
            .pipe(map((result) => this.resultsToBookmarks(result)), map((bookmarks) => bookmarks[0]));
    }
    resultsToBookmarks(result) {
        result.forEach((bookmark) => {
            bookmark.id = this.toAppContentId(bookmark.id);
            bookmark.tour = bookmark.tags.indexOf('tour') >= 0;
        });
        return plainToClass(BookmarkModel, result);
    }
    // Bookmark category is currently embedded as a tag inside a string array, making it
    // difficult to get to. This function checks for matches in the tags against the 
    // menu system and attempts to find match. 
    getBookmarkCategory(bookmark) {
        if (!bookmark.tags) {
            return null;
        }
        const tags = exploreMenu.categories.map(category => category.tag.toLocaleLowerCase());
        return bookmark.tags.find(tag => tags.includes(tag.toLocaleLowerCase()));
    }
    getStoryCategory(story) {
        if (!story.tags) {
            return null;
        }
        const tags = exploreMenu.categories.map(category => category.tag.toLocaleLowerCase());
        return story.tags.find(tag => tags.includes(tag.toLocaleLowerCase()));
    }
    // Normalizes id to app formatted id (i.e., production/maleAdult/flu)
    toAppContentId(id) {
        return id.replace('Condition.content.', '')
            .replace('.json', '')
            .split('.')
            .join('/');
    }
    // Normalizes id to DB format (i.e., Condition.content.production.maleAdult.flu.json)
    toDatabaseContentId(id) {
        if (!id.match('Condition.content')) {
            const normalizedId = id.replace('.json', '').split('/').join('.');
            return `Condition.content.${normalizedId}.json`;
        }
        else {
            return id;
        }
    }
}
ExploreService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ExploreService_Factory() { return new ExploreService(i0.ɵɵinject(i1.HttpClient)); }, token: ExploreService, providedIn: "root" });
